// What a planned trade's card says about WHY it exists (DWLF-302), read from the trade the API wrote:
// the strategy that fired (its name without the engine's "[LIVE] on <date>" suffix), when and on which
// timeframe it fired, and what the stop is anchored to. Presentation only; nothing is computed, and a
// field the trade doesn't carry is left out rather than shown as 0 or "undefined".

const TF = { '1d': 'daily', daily: 'daily', '1w': 'weekly', weekly: 'weekly', '1h': 'hourly', hourly: 'hourly', '4h': '4-hour' };
// A real number, never null/'' (Number(null) and Number('') are 0 and would pass isFinite).
export const num = (v) => (v === null || v === undefined || v === '' ? null : (Number.isFinite(Number(v)) ? Number(v) : null));
const day = (iso) => {
  const t = Date.parse(iso);
  return Number.isFinite(t) ? new Date(t).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', timeZone: 'UTC' }) : null;
};
const price = (v) => (num(v) === null ? null : num(v).toLocaleString('en-GB', { maximumFractionDigits: 2 }));

// The engine writes "<strategy name> [TAG] on YYYY-MM-DD". Only that exact suffix (tag required,
// whole word "on") is read as one; any other text — including user-written reasons — is left whole.
const ENGINE_SUFFIX = /^(.*?)\s+\[[A-Z]+\]\s+on (\d{4}-\d{2}-\d{2})$/;
export const parseReasonText = (text) => {
  const s = String(text || '').trim();
  const m = s.match(ENGINE_SUFFIX);
  return m ? { name: m[1].trim(), firedOn: m[2] } : { name: s, firedOn: null };
};

// The pivot's side from its event type's dotted segment (cycle.low.confirmed → low), never a substring.
const pivotSide = (eventType) => {
  const parts = String(eventType || '').split('.');
  if (parts.includes('high')) return 'high';
  if (parts.includes('low')) return 'low';
  return null;
};

export const stopNote = (anchor) => {
  if (!anchor || anchor.source !== 'cycle_pivot') return null;
  const side = pivotSide(anchor.pivotEventType);
  if (!side) return null;
  const tf = TF[anchor.timeframe] || null;
  const at = [day(anchor.pivotDate), price(anchor.pivotPrice)].filter(Boolean).join(' at ');
  const buffer = num(anchor.bufferPct);
  const detail = [at, buffer === null ? null : `${buffer}% buffer`].filter(Boolean).join(', ');
  return `${side === 'high' ? 'Above' : 'Under'} the ${tf ? `${tf} ` : ''}cycle ${side}${detail ? ` (${detail})` : ''}`;
};

export function signalReasons(trade) {
  if (!trade) return [];
  const { name, firedOn } = parseReasonText(trade.reasonText);
  const lines = [];
  if (firedOn) {
    if (name) lines.push({ label: 'Strategy', text: name });
    lines.push({ label: 'Fired', text: [day(firedOn), TF[trade.timeframe]].filter(Boolean).join(' · ') });
  } else {
    // Not engine-written: a line of clauses, each its own reason.
    name.split(/\s*(?:·|;|\n)\s*/).filter(Boolean).slice(0, 4).forEach((text) => lines.push({ label: null, text }));
  }
  const stop = stopNote(trade.stopAnchor);
  if (stop) lines.push({ label: 'Stop', text: stop });
  return lines;
}
